// extracted by mini-css-extract-plugin
export default {"topicModule":"index_topicModule_wz5dG","topicModule_title":"index_topicModule_title_HIidO","topicModule_box":"index_topicModule_box_CwUX5"};